export default __webpack_public_path__ + "static/exp2-aa26747ca54a21cd30472c38889623da.webp";